import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { BulkSchedulingStateService } from 'app/main/plus/calendar/bulk-scheduling.state.service';
import { CalendarSelectionStateService } from 'app/main/plus/calendar/calendar-selection.state.service';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseNavigationItem } from '@fuse/types';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { GlobalService } from 'app/global.service';
import { Observable, pipe, Subject, Subscription, takeUntil } from 'rxjs';
import { ContentModule } from '../components/content/content.module';
import { TopNavSmallComponent } from '../common/top-nav-small/top-nav-small.component';
import { BottomNavbarComponent } from '../common/bottom-navbar/bottom-navbar.component';
import { PageActionComponent } from '../common/page-action/page-action.component';
import { SmallNavigationService } from 'app/core/services/small-navigation-sevice.service';
import { CalendarDateButtonsComponent } from '../common/calendar-date-buttons/calendar-date-buttons.component';
import { Platform } from '@angular/cdk/platform';
import { EventStreamService } from 'app/main/plus/calendar/event-stream.service';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { animate, style, transition, trigger } from '@angular/animations';
import { EventFlowService } from 'app/main/plus/calendar/event-flow.service';
import { TranslocoService } from '@ngneat/transloco';
@Component({
  selector: 'small-layout',
  standalone: true,
  imports: [
    MatToolbarModule, 
    MatButtonModule, 
    MatIconModule,
    FlexLayoutModule,
    CommonModule,
    ContentModule,
    TopNavSmallComponent,
    BottomNavbarComponent,
    PageActionComponent,
    CalendarDateButtonsComponent,
    MatChipsModule,
    MatMenuModule,
  ],
  templateUrl: './small-layout.component.html',
  styleUrls: ['./small-layout.component.scss'],
  animations: [
    trigger('slideUp', [
      transition(':enter', [
        style({ 
          transform: 'translateY(100%)',
          opacity: 0 
        }),
        animate('300ms ease-out', style({ 
          transform: 'translateY(0)',
          opacity: 1 
        }))
      ]),
      transition(':leave', [
        animate('250ms ease-in', style({ 
          transform: 'translateY(100%)',
          opacity: 0 
        }))
      ])
    ])
  ]
})

export class SmallLayoutComponent {

  private _unsubscribeAll: Subject<any>;
  navigation$ : Observable<FuseNavigationItem[]>
  navigation: any = [];
  isCalendarRoute: boolean = false;
  @ViewChild('contentWrapper', { static: true })
  contentWrapper!: ElementRef<HTMLElement>;
  hideNav = false;
  private lastScrollTop = 0;

  currentEvents: any[] = [];
  isConnected = false;
  connectionError: string | null = null;
  private streamSubscription?: Subscription;
  showParticipantList = false;

  constructor(
    private _globalService : GlobalService,
    public smallNavService: SmallNavigationService,
    private router: Router,
    public _platform: Platform,
    private _eventStreamService: EventStreamService,
    private _bulkSchedulingStateService: BulkSchedulingStateService,
    private _calendarSelectionStateService: CalendarSelectionStateService,
    private _eventFlowService: EventFlowService,
    private _translocoService: TranslocoService,
  ){
  }

  get isRtl(): boolean {
    return this._translocoService.getActiveLang() === 'ar';
  }

  get isBulkModeActive(): boolean {
    return this.router.url.startsWith('/calendar') && this._bulkSchedulingStateService.isActive();
  }

  get bulkPanelHeightPx(): string {
    return `${this._bulkSchedulingStateService.mobilePanelHeight()}px`;
  }

  get isMultiSelectActive(): boolean {
    return this._calendarSelectionStateService.isMultiSelectActive();
  }

  ngOnInit(){
    this.connectToStream();
    this._unsubscribeAll = new Subject();
    this.navigation$ = this._globalService.currentBottomNavigation;
    
    // Check initial route
    this.checkIfCalendarRoute(this.router.url);

    // Ensure signals are initialized for the current route
    this.smallNavService.refreshStateForCurrentRoute();
    
    // Subscribe to route changes
    this.router.events.pipe(
      takeUntil(this._unsubscribeAll)
    ).subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {
        this.checkIfCalendarRoute(event.url);
      }
    });
  }
  // ngAfterViewInit() {
  //   // listen in capture phase so we catch scrolls from any descendant
  //   this.contentWrapper.nativeElement.addEventListener(
  //     'scroll',
  //     this.onAnyScroll,
  //     { capture: true }
  //   );
  // }
  
  
  private onAnyScroll(event: Event) {
    console.log("scroolll");
    const target = event.target as HTMLElement;
    const scrollTop = target.scrollTop;

    // scrolling down → hide; scrolling up → show
    this.hideNav = scrollTop > this.lastScrollTop;
    this.lastScrollTop = scrollTop;
  }

  
  // Helper method to check if current route is /calendar
  private checkIfCalendarRoute(url: string): void {
    this.isCalendarRoute = url.startsWith('/calendar');
  }

  ngOnDestroy(){
    // this.contentWrapper.nativeElement.removeEventListener(
    //   'scroll',
    //   this.onAnyScroll,
    //   { capture: true }
    // );
    this.disconnect();
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }

  /**
   * Connect to the SSE stream
   */
  connectToStream(): void {
    console.log('Connecting to event stream...');
    
    this.streamSubscription = this._eventStreamService
      .connectToEventStream()
      .subscribe({
        next: (data) => {
          console.log('[SSE] Received data:', data);
          if (data.error) {
            this.connectionError = data?.error;
            this.currentEvents = [];
          } else {
            this.connectionError = null;
            const newEvents = data?.currentEvents || [];
            // Simple check: only update if different
            if (!this.areEventsEqual(this.currentEvents, newEvents)) {
              this.currentEvents = newEvents;
              console.log("this.currentEvents==>",this.currentEvents);
            }
            this.isConnected = true;
          }
        },
        error: (error) => {
          console.error('Stream error:', error);
          this.connectionError = 'Connection lost. Retrying...';
          this.isConnected = false;
          
          // Retry logic
          setTimeout(() => {
            if (!this._eventStreamService.isConnected()) {
              this.connectToStream();
            }
          }, 5000);
        },
        complete: () => {
          console.log('Stream completed');
          this.isConnected = false;
        }
      });
  }
  
  private areEventsEqual(current: any[], incoming: any[]): boolean {
    if (current.length !== incoming.length) return false;
    
    return current.every((event, index) => {
      const incomingEvent = incoming[index];
      return event.id === incomingEvent.id &&
            event.startTime === incomingEvent.startTime &&
            event.endTime === incomingEvent.endTime &&
            event.title === incomingEvent.title &&
            event.candidateName === incomingEvent.candidateName;
    });
  }
  /**
   * Disconnect from the stream
   */
  disconnect(): void {
    if (this.streamSubscription) {
      this.streamSubscription.unsubscribe();
    }
    this._eventStreamService.disconnect();
    this.isConnected = false;
  }
  
  /**
   * Reconnect to the stream
   */
  reconnect(): void {
    this.disconnect();
    this.connectToStream();
  }

  get showChip(): boolean {
    return this.currentEvents && this.currentEvents.length > 0;
  }

  get chipLabel(): string {
    if (this.currentEvents.length === 1) {
      return this.currentEvents[0].candidateName;
    }
    return `+${this.currentEvents.length}`;
  }

  get hasMultipleParticipants(): boolean {
    return this.currentEvents.length > 1;
  }

  toggleParticipantList(): void {
    if (this.hasMultipleParticipants) {
      this.showParticipantList = !this.showParticipantList;
    }
  }

  closeParticipantList(): void {
    this.showParticipantList = false;
  }
  handleOngoingEventClick(): void {
  if (this.hasMultipleParticipants) {
    this.toggleParticipantList();
    return;
  }

  this.openOngoingEventDialog(this.currentEvents[0]);
}

openOngoingEventDialog(event: any): void {
  const category = this.getOngoingEventCategory(event);

  if (!event?.id || !category) {
    return;
  }

  this.showParticipantList = false;
  this._eventFlowService.editEvent(event.id, category, true, false);
}

private getOngoingEventCategory(event: any): string | null {
  if (event.type === 'busy') return 'busy';
  if (event.type?.startsWith('code')) return 'code';
  if (event.type?.startsWith('conduite')) return 'conduite';

  return null;
}

}
